import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isNumeric } from 'utilities';

// two parts to using this component: wrap the input to give it the counter
// and give the input a max-length prop with a matching limit.
// see storybook for an example

// use: LimitedTextarea = withCharacterLimit(100)(Textarea)
export const withCharacterLimit = limit => (Component) => {
  const Container = ({ value, ...rest }) => (
    <CharacterLimitCounter text={value} limit={limit}>
      <Component
        {...rest}
        maxLength={limit}
        value={value}
      />
    </CharacterLimitCounter>
  );
  Container.propTypes = {
    value: PropTypes.any
  };
  Container.defaultProps = {
    value: null
  };
  return Container;
};

const StyledCounter = styled.div`
  position: relative;
  .counter {
    position: absolute;
    bottom: 0px;
    right: 10px;
    z-index: 1;
    font-size: 60%;
  }
  &.at-limit .counter {
    color: ${({ theme }) => theme.colors.poor};
    font-weight: bold; 
  }
`;

const makeClassNames = (limit, text) => {
  const classNames = ['CharacterLimitCounter'];
  if (text.length >= limit) {
    classNames.push('at-limit');
  }
  const classNameString = classNames.join(' ');
  return classNameString;
};

// if we have a limit, the minimum is 1
const constrainLimit = limit => ((limit > 1) ? limit : 1);

const CharacterLimitCounter = ({ limit, text, children }) => {
  if (isNumeric(limit) === false) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  const enforcedLimit = constrainLimit(limit);
  const classNameString = makeClassNames(enforcedLimit, text);
  return (
    <StyledCounter className={classNameString}>
      {children}
      <div className="counter">
        {text.length}
        /
        {enforcedLimit}
      </div>
    </StyledCounter>
  );
};

CharacterLimitCounter.propTypes = {
  limit: PropTypes.number,
  text: PropTypes.string,
  children: PropTypes.node.isRequired
};

CharacterLimitCounter.defaultProps = {
  limit: undefined,
  text: ''
};

export default CharacterLimitCounter;
